import styled, { css } from 'styled-components';

interface InputProps {
  hasError?: boolean;
}

export const Input = styled.input<InputProps>`
  background: ${props => props.theme.colors.inputBackgroundGrey};
  border: 1px solid ${props => props.theme.colors.inputBorderGrey} !important;
  padding: 0 10px;
  font-size: 1.1rem !important;
  max-width: 100%;
  width: 100%;
  border-radius: 3px !important;
  height: 30px;
  margin: 3px 0px;
  /* line-height: 35px; */
  transition: all 0.3s ease-in-out;
  &:focus {
    border-color: ${props => props.theme.colors.siteBlue} !important;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.focusShadowSiteBlue} !important;
  }

  ${props => {
    if (props.hasError) {
      return css`
        border-color: ${props.theme.colors.tooltip.red}!important;
      `;
    }
  }}
`;

export type TextInputsProps = {
  onChange: (e: any) => void | string | null;
  value?: string | null;
  disabled?: boolean;
  maxLength?: number;
  autoComplete?: string;
  placeholder?: string;
  id?: string;
  fieldRef?:
    | ((instance: HTMLInputElement | null) => void)
    | React.RefObject<HTMLInputElement>
    | null;
  type?: string;
  className?: string;
  onKeyDown?: (e: any) => void;
};

export const TextInput = ({ onChange, value, fieldRef, ...props }: TextInputsProps) => (
  <Input
    ref={fieldRef}
    className="textInput"
    onChange={e => onChange(e.target.value)}
    value={value === null ? '' : value}
    {...props}
  />
);
